import React from "react";
import { Box, Typography, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import squirrel from "../../images/sqrl-01.svg";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    padding: "48px 24px",
  },
  image: {
    width: 72,
    opacity: 0.4,
    marginBottom: 16,
  },
  message: {
    maxWidth: 360,
    marginTop: 4,
  },
});

/**
 * Friendly empty state: dimmed squirrel mark, a title, optional supporting
 * message and call-to-action.
 */
const EmptyState = ({ title, message, actionLabel, onAction }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <img src={squirrel} alt="" className={classes.image} />
      <Typography variant="h5">{title}</Typography>
      {message && (
        <Typography variant="body2" className={classes.message}>
          {message}
        </Typography>
      )}
      {actionLabel && (
        <Box mt={2}>
          <Button variant="contained" color="primary" onClick={onAction}>
            {actionLabel}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default EmptyState;
